import { axios } from 'shared/services/axios'

export function fetchCategories(boardId, abortSignal) {
  return axios.get(
    `/api/v1/boards/${boardId}/categories`,
    { signal: abortSignal }
  )
    .then(response => response.data)
}

export function createCategory(boardId, { name, categoryType, url, position, description, captcha }) {
  return axios.post(
    `/api/v1/boards/${boardId}/categories`, {
      name,
      category_type: categoryType,
      url,
      position,
      description,
      captcha
    })
    .then(response => response.data)
}

export function createSubcategory(boardId, subcategory) {
  return axios.post(
    `/api/v1/boards/${boardId}/subcategories`, {
      name: subcategory.name,
      category_type: subcategory.categoryType,
      parent_category_id: subcategory.parentCategoryId,
      position: subcategory.position,
      description: subcategory.description,
      url: subcategory.url
    })
    .then(response => response.data)
}

export function updateCategory({ id, name, url, position, description }) {
  return axios.put(
    `/api/v1/categories/${id}`, {
      name,
      url,
      position,
      description
    })
    .then(response => response.data)
}

export function updateCategoryItem({ categoryId, itemId, position }) {
  return axios.post(
    `/api/v1/categories/${categoryId}/category_items`, {
      item_id: itemId,
      position
    })
    .then(response => response.data)
}

export function addItem({ categoryId, itemId }) {
  return axios.post(
    `/api/v1/categories/${categoryId}/category_items`, {
      item_id: itemId
    })
    .then(response => response.data)
}

export function removeCategoryItem({ categoryId, itemId }) {
  return axios.delete(
    `/api/v1/categories/${categoryId}/category_items/${itemId}`)
    .then(response => response.data)
}

export function removeCategory(categoryId) {
  return axios.delete(`/api/v1/categories/${categoryId}`)
    .then(response => response.data)
}

export function removeSubcategory(categoryId) {
  return axios.delete(`/api/v1/subcategories/${categoryId}`)
    .then(response => response.data)
}
